import bobtailAPI from '../axiosConfig'
import Entity from './entity'

const InvoiceDocument = new Entity('invoicedocuments')

InvoiceDocument.regenerateDocs = async (id) => {
  return (await bobtailAPI()).get(`${InvoiceDocument.baseUrl}/regenerate-pdf/${id}`)
}

export default InvoiceDocument
